import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';
import Select from 'react-select';
import Overlay from '../../Miscelania/Overlay';

class CategoriesEditTab extends Component {  
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      id: '',
      name: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.editar = this.editar.bind(this);
  }
  //Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  // LM
  componentWillReceiveProps(newProps) {
      this.setState({
        id: newProps.category_id,
        name: newProps.category_data.name,
      });
  }  
  // Fetch salvando a edição
  editar(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      name: this.state.name,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/categoria', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  render() {
    return (
<div>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <h3 className="page-title pull-left">Editar categoria</h3>
  <Link to="/categorias" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
  <div className="clearfix"></div>
  <hr/>
  <form onSubmit={this.editar}>
    <div className="row">
      <div className="col-md-12">
        <div className="form-group">
          <label>Nome:</label>
          <input type="text" name="name" className="form-control" placeholder="Categoria" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-12">
        <button onClick={this.editar} className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar edição</button>
      </div>
    </div>
  </form>
</div>
    );
  }
}

export default CategoriesEditTab;



// WEBPACK FOOTER //
// ./src/Components/Categories/Elements/CategoriesEditTab.js